<div class="layout-sidebar-entity">
  <span class="layout-sidebar-entity__label">Entidade</span>

  <div class="layout-sidebar-entity__field">
    <i class="pi pi-building"></i>
    <p-select
      inputId="sidebar-entity-select"
      [options]="entitySelectionService.entityOptions()"
      optionLabel="label"
      optionValue="id"
      [placeholder]="entitySelectionService.entityPlaceholder()"
      [ngModel]="entitySelectionService.selectedEntityId()"
      (ngModelChange)="entitySelectionService.selectEntityById($event)"
      [ngModelOptions]="{ standalone: true }"
      [loading]="entitySelectionService.entitiesLoading()"
      [disabled]="
        entitySelectionService.entitiesLoading() ||
        !entitySelectionService.hasEntities() ||
        entitySelectionService.displayRequiredDialog()
      "
      appendTo="body"
      styleClass="layout-sidebar-entity__select"
      panelStyleClass="entity-select-panel"
    >
      <ng-template pTemplate="selectedItem" let-option>
        <span class="entity-select-value">{{ option.label }}</span>
      </ng-template>

      <ng-template pTemplate="item" let-option>
        <div
          class="entity-select-option"
          [class.entity-select-option--root]="option.depth === 0"
        >
          <span
            *ngIf="option.depth > 0"
            class="entity-select-option__guides"
            aria-hidden="true"
          >
            <span
              *ngFor="let guide of option.guides; let isLast = last"
              class="entity-select-option__guide"
              [class.entity-select-option__guide--branch]="isLast"
            ></span>
          </span>

          <span class="entity-select-option__label">{{ option.label }}</span>
        </div>
      </ng-template>
    </p-select>
  </div>
</div>

<app-menu></app-menu>
